








































import sizeMixin from '@/product/mixins/sizeMixin'
import debounce from 'lodash/debounce'

import SizeInput from '@/common/components/SizeInput.vue'
import SizeInputError from '@/common/components/SizeInputError.vue'

import { PRODUCT_SELECTION_ERROR_TYPES } from '@/product/types'

export default sizeMixin.extend({
  components: {
    SizeInput,
    SizeInputError
  },
  props: {
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    updateSizeQuantityDebounce: (() => void) | undefined
  } {
    return {
      updateSizeQuantityDebounce: undefined
    }
  },
  mounted() {
    this.updateSizeQuantityDebounce = debounce(this.updateSizeQuantity, 500)
  },
  computed: {
    highlightSizesSelection(): boolean {
      return this.$_storeState.selectionErrors[
        PRODUCT_SELECTION_ERROR_TYPES.PRODUCT_SIZE
      ].highlightInvalidElement
    },
    sizeSelectionErrorMessage(): string {
      return this.$_storeState.selectionErrors[
        PRODUCT_SELECTION_ERROR_TYPES.PRODUCT_SIZE
      ].errorMessage || ''
    }
  },
  methods: {
    onChange() {
      this.updateSizeQuantityDebounce && this.updateSizeQuantityDebounce()
    },
    updateSizeQuantity() {
      this.$_validateTotalQuantity()
      if (this.errors.length === 0) {
        this.$_onChangeSizeInput()
      }
    }
  }
})
